
/**
 * Notifications Tab Help Content
 */
const NotificationsHelp = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Notifications
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Configure how and when you receive alerts and notifications from Aivilo Lens. Stay informed about important events across all your monitored systems.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Notification Channels
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">In-App</span>: Notifications within the Lens UI</p>
          <p>&#8226; <span className="font-medium">Email</span>: Alerts sent to your email address</p>
          <p>&#8226; <span className="font-medium">Slack</span>: Integration with Slack channels</p>
          <p>&#8226; <span className="font-medium">Webhook</span>: Custom HTTP endpoints</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Alert Types
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Configure notifications for different event categories:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Cost Alerts</span>: Budget thresholds and anomalies</p>
          <p>&#8226; <span className="font-medium">Compliance</span>: Policy violations and guardrail triggers</p>
          <p>&#8226; <span className="font-medium">Performance</span>: Latency spikes and error rate increases</p>
          <p>&#8226; <span className="font-medium">Security</span>: Failed logins and access issues</p>
          <p>&#8226; <span className="font-medium">System</span>: Environment status changes</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Alert Rules
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Create custom alert rules with:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Conditions</span>: Metric thresholds and triggers</p>
          <p>&#8226; <span className="font-medium">Severity</span>: Critical, Warning, Info levels</p>
          <p>&#8226; <span className="font-medium">Recipients</span>: Who receives the alert</p>
          <p>&#8226; <span className="font-medium">Schedule</span>: Quiet hours and frequency limits</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Managing Preferences
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Toggle notifications on/off per category, set digest frequency for non-urgent alerts, and configure escalation paths for critical issues.
        </p>
      </div>

      <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
        <p className="text-xs text-gray-500 dark:text-gray-500">
          View notification history in the <span className="font-medium">Notifications</span> page (bell icon in header).
        </p>
      </div>
    </>
  );
};

export default NotificationsHelp;
